import React from "react";
import { useFormik, FieldArray, FormikProvider, ErrorMessage } from "formik";
import { Container, Button, Modal } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { toast } from "react-toastify";

import Select from "react-select";
import currency from "currency.js";
import { convertToBaseCurrency } from "../../utils/helpers";
import { useStoreState } from "easy-peasy";

const RecievePurchaseGRNModal = ({ show, setShow, InvoiceNo, refetch }) => {
  const { backendUrl, token } = useAuth();
  const initialValues = {
    items: [{ Item_Name: "", UnitCost: "", Quantity: "", StorageLocation: "" }],
  };
  const generalSettings = useStoreState(state => state.generalSettings);

  const validate = values => {
    const errors = {};
    /*  if (!values.items || values.items.length === 0) {
      errors.items = "At least one item is required";
    } else { */
    const itemErrors = [];
    values.items.forEach((item, index) => {
      const itemError = {};

      // Do not validate a service item
      if (item?.Bar_Code?.includes("SERVICE")) {
        return;
      }

      if (!item.Item_Name) {
        itemError.Item_Name = "Item name is required";
      }
      if (!item.UnitCost) {
        // itemError.UnitCost = "Unit cost is required";
      } else if (isNaN(item.UnitCost) || parseFloat(item.UnitCost) < -1) {
        itemError.UnitCost = "Unit cost must be a valid positive number";
      }
      if (!item.Quantity) {
        itemError.Quantity = "Quantity is required";
      } else if (isNaN(item.Quantity) || parseInt(item.Quantity) < 1) {
        itemError.Quantity = "Quantity must be a valid positive integer";
      }
      // else if (!item.StorageLocation && !item.Bar_Code.includes("SERVICE")) {
      //   itemError.StorageLocation = "Select a Storage Location";
      // }

      if (Object.keys(itemError).length > 0) {
        itemErrors[index] = itemError;
      }
    });
    if (itemErrors.length > 0) {
      errors.items = itemErrors;
    }

    // }
    return errors;
  };

  const updateItem = async payload => {
    payload.items = payload.items.map(item =>
      item.currency && item.currency !== generalSettings?.prevailingCurrency
        ? convertToBaseCurrency({
            data: item,
            conversionAmount: item.conversionAmount,
          })
        : item
    );

    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));

    if (payload?.invoiceFile) {
      for (const file of payload.invoiceFile) {
        formData.append(`invoiceFile`, file);
      }
    }

    let response = await fetch(
      `${backendUrl}/api/invexcloud/save-to-warehouse`,
      {
        method: "POST",
        credentials: "include",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const updateMutation = useMutation(payload => updateItem(payload), {
    onSuccess: ({ message, data }) => {
      if (refetch) {
        refetch();
      }
      toast.success(message);
      setShow(false);
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
    },
  });

  const formik = useFormik({
    initialValues,
    validate,
    onSubmit: values => {
      // console.log("Form values:", values);
      updateMutation.mutate({ ...values });
    },
  });

  const fetchPurchaseHistory = async () => {
    //  alert("...");
    // await waitFor(5000);
    let response = await fetch(
      `${backendUrl}/api/invexcloud/purchase-request-grn-by-invoice/${InvoiceNo}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();

    data.warehouses = data.warehouses?.map(el => ({
      ...el,
      value: el.W_ID,
      label: el.W_name,
    }));

    // DATA MUST GO SOMEHWERE, EMPTY MEANS SALES INVENTORY
    data.warehouses.unshift({ value: "", label: "Sales Inventory" });

    data.storageLocations = data.storageLocations.map(el => ({
      ...el,
      value: el.Storage_ID,
      label: el.storage_location,
    }));

    // set initials items
    formik.setFieldValue(
      "items",
      data.items
        //  .filter(el => !el?.Bar_Code.includes("SERVICE"))
        .map(el => ({
          ...el,
          UnitCost: el?.UnitCost || 0,
          StorageLocation: "",
        }))
    );

    return data;
  };

  const {
    data = {
      warehouses: [],
      items: [],
    },
    //  refetch,
    isFetching,
    isSuccess,
  } = useQuery(
    ["ITEMS_FOR_PURCHASE", InvoiceNo],
    () => fetchPurchaseHistory(),
    {
      keepPreviousData: true,
    }
  );

  return (
    <Container className="mt-4">
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        centered
        fullscreen
        backdrop="static"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Send to Stock - {InvoiceNo} - {show.vendorName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit}>
              <FieldArray
                name="items"
                render={arrayHelpers => (
                  <>
                    <div className="table-responsive mb-3 product-table border">
                      <table className="table table-borderless table-striped align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>
                              Warehouse{" "}
                              {/* <Button
                                size="sm"
                                type="button"
                                variant="outline-primary"
                                onClick={() => {
                                  if (formik.values.items.length > 0) {
                                    const firstWarehouse = formik.values.items[0].Warehouse;
                                    formik.values.items.forEach((item, idx) => {
                                      formik.setFieldValue(
                                        `items.${idx}.Warehouse`,
                                        firstWarehouse
                                      );
                                    });
                                  }
                                }}
                              >
                                Cascade
                              </Button> */}
                            </th>

                            <th>Item Name</th>
                            <th>Storage Location</th>
                            <th>Unit Cost</th>
                            <th>Quantity</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formik.values.items.map((item, index) => (
                            <tr
                              key={index}
                              style={
                                item?.Bar_Code?.includes("SERVICE")
                                  ? { pointerEvents: "none", opacity: 0.5 }
                                  : {}
                              }
                            >
                              <td>{index + 1}</td>
                              <td>
                                <div style={{ width: "210px" }}>
                                  <Select
                                    name={`items.${index}.Warehouse`}
                                    options={data.warehouses}
                                    value={
                                      data.warehouses.find(
                                        w => w.value === item.Warehouse
                                      ) || null
                                    }
                                    onChange={selected =>
                                      formik.setFieldValue(
                                        `items.${index}.Warehouse`,
                                        selected ? selected.value : ""
                                      )
                                    }
                                    onBlur={() =>
                                      formik.setFieldTouched(
                                        `items.${index}.Warehouse`,
                                        true
                                      )
                                    }
                                    placeholder=" "
                                    isClearable
                                    menuPosition="fixed"
                                  />
                                  {formik.errors.items?.[index]?.Warehouse &&
                                    formik.touched.items?.[index]
                                      ?.Warehouse && (
                                      <div className="invalid-feedback d-block">
                                        {formik.errors.items[index].Warehouse}
                                      </div>
                                    )}
                                </div>
                              </td>

                              <td>
                                <input
                                  name={`items.${index}.Item_Name`}
                                  type="text"
                                  className={`form-control ${
                                    formik.errors.items?.[index]?.Item_Name &&
                                    formik.touched.items?.[index]?.Item_Name
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  placeholder="Enter item name"
                                  value={item.Item_Name}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  readOnly
                                />
                                {formik.errors.items?.[index]?.Item_Name &&
                                  formik.touched.items?.[index]?.Item_Name && (
                                    <div className="invalid-feedback">
                                      {formik.errors.items[index].Item_Name}
                                    </div>
                                  )}
                              </td>

                              <td>
                                <Select
                                  classNamePrefix={`form-select`}
                                  options={data.storageLocations}
                                  value={data.storageLocations?.find(
                                    el =>
                                      el.value ===
                                      formik.values.items[index].StorageLocation
                                  )}
                                  onChange={select =>
                                    formik.setFieldValue(
                                      `items.${index}.StorageLocation`,
                                      select?.value
                                    )
                                  }
                                  onBlur={() =>
                                    formik.setFieldTouched(
                                      `items.${index}.StorageLocation`,
                                      true
                                    )
                                  }
                                  placeholder="Storage Location"
                                  menuPosition="fixed"
                                />

                                <ErrorMessage
                                  component="span"
                                  className="text-danger mb-2"
                                  name={`items.${index}.StorageLocation`}
                                />
                              </td>

                              <td>
                                <input
                                  name={`items.${index}.UnitCost`}
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  className={`form-control ${
                                    formik.errors.items?.[index]?.UnitCost &&
                                    formik.touched.items?.[index]?.UnitCost
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  placeholder="0.00"
                                  value={item.UnitCost}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  readOnly
                                />
                                {formik.errors.items?.[index]?.UnitCost &&
                                  formik.touched.items?.[index]?.UnitCost && (
                                    <div className="invalid-feedback">
                                      {formik.errors.items[index].UnitCost}
                                    </div>
                                  )}
                              </td>
                              <td>
                                <input
                                  name={`items.${index}.Quantity`}
                                  type="number"
                                  min="1"
                                  className={`form-control ${
                                    formik.errors.items?.[index]?.Quantity &&
                                    formik.touched.items?.[index]?.Quantity
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  placeholder="1"
                                  value={item.Quantity}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  readOnly
                                />
                                {formik.errors.items?.[index]?.Quantity &&
                                  formik.touched.items?.[index]?.Quantity && (
                                    <div className="invalid-feedback">
                                      {formik.errors.items[index].Quantity}
                                    </div>
                                  )}
                              </td>
                              <td>
                                {currency(
                                  item.UnitCost && item.Quantity
                                    ? (
                                        parseFloat(item.UnitCost || 0) *
                                        parseInt(item.Quantity || 0)
                                      ).toFixed(2)
                                    : "0.00",
                                  {
                                    symbol: "",
                                  }
                                ).format()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan="4" className="text-end">
                              <strong>Total:</strong>
                            </td>
                            <td colSpan="2">
                              <strong>
                                {currency(
                                  formik.values.items
                                    .reduce((total, item) => {
                                      const itemTotal =
                                        parseFloat(item.UnitCost || 0) *
                                        parseInt(item.Quantity || 0);
                                      return total + itemTotal;
                                    }, 0)
                                    .toFixed(2),
                                  {
                                    symbol: "",
                                  }
                                ).format()}
                              </strong>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                    {/* <div className="mb-4">
                      <Button
                        variant="outline-primary"
                        type="button"
                        onClick={() =>
                          arrayHelpers.push({
                            Item_Name: "",
                            UnitCost: "",
                            Quantity: "",
                            Warehouse: "",
                            StorageLocation:""
                          })
                        }
                      >
                        + Add Item
                      </Button>
                    </div> */}
                  </>
                )}
              />
              <div className="d-flex justify-content-end gap-2">
                <Button
                  variant="primary"
                  type="submit"
                  size="lg"
                  className="px-4"
                  disabled={updateMutation.isLoading}
                >
                  {updateMutation.isLoading ? "Submitting..." : "Post"}
                </Button>
              </div>
            </form>
          </FormikProvider>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default RecievePurchaseGRNModal;
